import { Divider } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import ButtonIcon from "./buttons/ButtonIcon";
import { IconExpandable } from "./buttons/IconButtons";
import {calculateHeight} from "../Apis/functions";

/**
 * @Email       : azapata@ibl.mx
 * @Author      : Ferro Zapata Arnulfo
 * @JobTitle    : Full Stack Developer
 *
 * @Description
 * Expandable card component that smoothly shows or hides its children using dynamic `max-height` transitions.
 * This version fixes the initial render issue where the card appeared closed despite `isOpen` being true.
 * It uses `useLayoutEffect` to ensure the DOM is updated **before the first paint**, and a `ResizeObserver`
 * to recalculate height when the internal content changes dynamically.
 *
 * @param {Object} props - React props
 * @param {React.ReactNode} props.header - The header content displayed at the top of the card.
 * @param {React.ReactNode} props.children - The collapsible content to be shown or hidden.
 * @param {string} [props.classCustomCard] - Additional custom class for the `CustomCard` wrapper.
 * @param {string} [props.dividerClassName="my-3"] - Custom class for the divider element.
 * @param {boolean} [props.defaultOpen=true] - Whether the card starts expanded or collapsed.
 *
 */

const CustomExpandableCard = ({ header, children, classCustomCard, dividerClassName = "my-3", searchInput = false }) => {
    const [isOpen, setIsOpen] = useState(true);
    const contentRef = useRef(null);

    const toggleOpen = () => {
        setIsOpen(!isOpen);
    };

    useEffect(() => {
        if (contentRef.current) {
            if (isOpen) {
                calculateHeight({elementRef: contentRef, bottom:150})
            } else {
                contentRef.current.style.height = "0px";
            }
        }
    }, [isOpen]);

    return (
        <div className={`mt-3 mb-3 position-absolute top-0 l-15px z-index-1000 card-border-8px p-16px w-400px h-auto
        border-full-shades-100 background-general-00 ${classCustomCard}`}>
            <div className={"flex-row justify-content-between"}>
                {header}
                <div className="justify-content-end">
                    <ButtonIcon
                        className="background-transparent"
                        iconProps="icon-color-shades-400 icon-hover-general-950 btn-icon-svg-24px"
                        id="btn_am_expandable"
                        Icon={IconExpandable}
                        onClick={toggleOpen}
                    />
                </div>
            </div>
            {searchInput && searchInput}
            <Divider className={dividerClassName} />
            <div className={"expandable-container overflow-hidden"} ref={contentRef}>
                {children}
            </div>
        </div>
    );
};

export default CustomExpandableCard;
